function Receipts() {
  return (
    <div>
      <h1>Receipts</h1>
      <p>Welcome to Club OS Receipts</p>
    </div>
  );
}

export default Receipts;
